;(function () {
  angular
    .module('contrast.integrations')
    .controller(
      'csIntegrationCredentialsRenameCtrl',
      csIntegrationCredentialsRenameCtrl
    )

  function csIntegrationCredentialsRenameCtrl($scope, $uibModalInstance, name) {
    angular.extend($scope, {
      model: {
        name: name
      }
    })

    angular.extend($scope, {
      save: save,
      cancel: cancel
    })

    function save() {
      $uibModalInstance.close($scope.model)
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }
  }
})()
